import { createTranslationFile, createLanguage } from "@vocab/core/runtime";
const translations = createTranslationFile({
  en: createLanguage({ New: "New" }),
  th: createLanguage({ New: "New" }),
  id: createLanguage({ New: "Baru" }),
  zh: createLanguage({ New: "最新" }),
  "en-AU": createLanguage({ New: "New" }),
  "en-HK": createLanguage({ New: "New" }),
  "en-ID": createLanguage({ New: "New" }),
  "en-MY": createLanguage({ New: "New" }),
  "en-NZ": createLanguage({ New: "New" }),
  "en-PH": createLanguage({ New: "New" }),
  "en-SG": createLanguage({ New: "New" }),
  "en-TH": createLanguage({ New: "New" }),
  "th-TH": createLanguage({ New: "New" }),
  "id-ID": createLanguage({ New: "Baru" }),
  "zh-HK": createLanguage({ New: "最新" }),
  "en-PSEUDO": createLanguage({ New: "[Ñẽẽẽŵ]" })
});
export {
  translations
};
